module.exports = __webpack_public_path__ + "static/media/sf_2700_gray.2bf95e56c1ff82e719cf2bc298bb1e49.png";